import React, { type PropsWithChildren } from 'react';

import { Stack } from '@atlaskit/primitives/compiled';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { FeatureItem } from './feature-item/index.tsx';

const featuresStyles = cssMap({
	root: {
		width: '100%',
		alignItems: 'flex-start',
		listStyleType: 'none',
		paddingLeft: token('space.0'), // using this as an override, we should not use padding-[top|left|right|bottom]
		marginTop: token('space.0'),
		marginLeft: token('space.0'),
		gap: token('space.0'),
		alignContent: 'center',
	},
});

const Features = ({ children }: PropsWithChildren) => {
	return (
		<Stack as="ul" xcss={featuresStyles.root}>
			{children}
		</Stack>
	);
};

// Attach FeatureItem to Features
Features.Item = FeatureItem;

export { Features };
